<!--
     <FieldString>
-->

<template>
    <v-badge
          inline
          left
          :color="color"
          dot
        >
          {{ representation }}
        </v-badge>
    <!--<span>{{ representation }}</span>-->
  </template>
  
  <script>
   export default {
     name: 'FieldState',
  
     props: {
        'field': {required: true},
     },
  
     computed: {
       representation() {
         const value = ''+this.field.readable_text();
         return value;
       },
       color() {
        return this.field.dot_color()
       }
     },
   };
  </script>
  